import React from 'react'

const SpinnerCircle = (props) => {
  let klass = 'sk-spinner sk-spinner-circle spinner-circle-white'
  if (props.hasOwnProperty('extraKlass')) {
    klass += ' ' + props.extraKlass
  }
  if (!props.isActive) {
    return null
  }
  return (
    props.isActive && (
      <div className={klass} style={props.style}>
        <div className='sk-circle1 sk-circle' />
        <div className='sk-circle2 sk-circle' />
        <div className='sk-circle3 sk-circle' />
        <div className='sk-circle4 sk-circle' />
        <div className='sk-circle5 sk-circle' />
        <div className='sk-circle6 sk-circle' />
        <div className='sk-circle7 sk-circle' />
        <div className='sk-circle8 sk-circle' />
        <div className='sk-circle9 sk-circle' />
        <div className='sk-circle10 sk-circle' />
        <div className='sk-circle11 sk-circle' />
        <div className='sk-circle12 sk-circle' />
      </div>
    )
  )
}

export default SpinnerCircle
